// extracted by mini-css-extract-plugin
module.exports = {"modal":"popup_modal__1gwhb","showModal":"popup_showModal__19wYM","outer":"popup_outer__36pu4","close":"popup_close__1wFRx"};